import strings from 'constants/index';

import { UTCSingleDate } from './formatter.utils';

export const compareDateStrings = (
  first: string,
  second: string,
  isFirstBefore = false,
): boolean | string => {
  const firstDate = new Date(first);
  const secondDate = new Date(second);

  if (isFirstBefore) {
    if (firstDate.getTime() > secondDate.getTime()) {
      return `${strings.start_date_before_validation} ${UTCSingleDate(second)}`;
    }

    return true;
  }

  if (firstDate.getTime() < secondDate.getTime()) {
    return `${strings.end_date_after_validation} ${UTCSingleDate(second)}`;
  }

  return true;
};

export const getHoursDiff = (first: string, second: string): number => {
  const firstDate = new Date(UTCSingleDate(first));
  const secondDate = new Date(second);

  const microSecondsDiff = Math.abs(firstDate.getTime() - secondDate.getTime());
  const hoursDiff = Math.floor(microSecondsDiff / (1000 * 60 * 60));

  return hoursDiff;
};

export const getCompetitorTypeFromCompetitionType = (competitionType: string): string | null => {
  if (!competitionType) {
    return strings.team;
  }

  switch (competitionType) {
    case 'Player Cup':
      return strings.player;
    case 'Doubles Cup':
      return strings.double;
    case 'Team Cup':
    case 'League':
    case 'Tournament':
      return strings.team;

    default:
      return strings.team;
  }
};
